import { useEffect, useState } from "react";
import { Flame, Skull } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const deviceId = () => {
  let id = localStorage.getItem("clipx_device");
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9-]/g, "");
    localStorage.setItem("clipx_device", id);
  }
  return id;
};
const readMine = () => { try { return JSON.parse(localStorage.getItem("clipx_reacts") || "{}"); } catch { return {}; } };

const TYPES = [
  ["fire", <Flame key="f" className="w-4 h-4" />, "#ff8a00"],
  ["skull", <Skull key="s" className="w-4 h-4" />, "#c79bff"],
  ["gg", <span key="g" className="font-display font-bold text-[11px] leading-none">GG</span>, "#22e3a1"],
];

export const Reactions = ({ sid, initial, size = "md", testid = "reactions" }) => {
  const [counts, setCounts] = useState(initial || { fire: 0, skull: 0, gg: 0 });
  const [mine, setMine] = useState(() => readMine()[sid] || []);
  useEffect(() => {
    if (size !== "lg") return;
    api.get(`/s/${sid}/reactions`, { params: { device: deviceId() } }).then(({ data }) => {
      setCounts(data.reactions);
      setMine(data.mine);
      localStorage.setItem("clipx_reacts", JSON.stringify({ ...readMine(), [sid]: data.mine }));
    }).catch(() => {});
  }, [sid, size]);
  const toggle = async (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    const on = !mine.includes(type);
    const next = on ? [...mine, type] : mine.filter((x) => x !== type);
    setMine(next);
    setCounts((c) => ({ ...c, [type]: Math.max(0, (c[type] || 0) + (on ? 1 : -1)) }));
    try {
      const { data } = await api.post(`/s/${sid}/react`, { type, device: deviceId(), on });
      setCounts(data.reactions);
      localStorage.setItem("clipx_reacts", JSON.stringify({ ...readMine(), [sid]: next }));
    } catch (err) {
      setMine(mine);
      setCounts((c) => ({ ...c, [type]: Math.max(0, (c[type] || 0) + (on ? -1 : 1)) }));
      toast.error(formatApiError(err));
    }
  };
  const pad = size === "lg" ? "px-4 py-2 text-sm" : "px-2.5 py-1 text-[11px]";
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testid}>
      {TYPES.map(([type, icon, color]) => {
        const active = mine.includes(type);
        return (
          <button key={type} onClick={(e) => toggle(e, type)} data-testid={`${testid}-${type}`} data-active={active}
            className={`flex items-center gap-1.5 rounded-full border font-mono transition-[transform,background-color,border-color] active:scale-90 hover:scale-105 ${pad} ${active ? "bg-white/10" : "bg-black/40 border-white/10 text-slate-300"}`}
            style={active ? { borderColor: color, color } : undefined}>
            {icon}<span data-testid={`${testid}-${type}-count`}>{counts[type] || 0}</span>
          </button>
        );
      })}
    </div>
  );
};
